<template>
  <div class="w-full flex flex-wrap items-center pl-2 md:pl-12 pr-2 md:pr-0 py-5 ">
    <inertia-link class="w-full md:w-9/12 flex flex-wrap items-center py-4" :href="$route('scheduler.posts.show',[postId,'edit'])">
    <div class="w-full md:w-6/12 lg:w-5/12 flex items-center">
      <MediaDisplay :mediaUrl="item.media_url" :mediaType="item.type" :format="'h-14 w-16 bg-gray-500 rounded-sm mr-3 mb-0 bg-cover bg-center bg-no-repeat'"/>  
      <p><span class=" font-bold">{{postDateDay}}</span> {{postDateMonthTime}}</p>
    </div>
    <div class="w-full md:w-2/6">
      <p class="text-sm mb-5 md:mb-0 mt-6 md:mt-0">{{ item.caption | truncate(30)}}</p>
    </div>
    <div class="flex flex-wrap relative items-center w-6/12 md:w-3/12">
      <PagePhoto 
        v-for="page in item.pages.slice(0,3)"
        :key="page.id"
        :imageUrl="getAccountImageUrl(page)"
        :social="page.provider"
        :isGroup="page.type === 'group'"
        :isGroupCover="isGroupCover(page)"
      />
      <span v-if="item.pages.length > 3" class="text-xs text-gray-500">+{{item.pages.length}}</span>
    </div>
    </inertia-link>
    <div class="flex items-center justify-between w-full lg:w-3/12 relative">
      <BadgeStatus :status="item.state"/>
      <button @click="confirmDelete({id: item.id, postDate: postDateMonthTime})" class="border static md:absolute right-10 border-platinumFire hover:shadow-lg p-2 rounded-lg">
        <TrashIcon/>
      </button>
    </div>
  </div>

</template>

<script>
import PagePhoto from '@/components/scheduler/Table/Row/partials/PagePhoto';
import BadgeStatus from '@/components/scheduler/Table/Row/partials/BadgeStatus';
import TrashIcon from '@/components/svg/TrashIcon';
import DropDown from '@/components/scheduler/Common/DropDown.vue';
import MediaDisplay from '@/components/scheduler/Common/MediaDisplay.vue';

import dayjs from 'dayjs';

var utc = require('dayjs/plugin/utc');
var timezone = require('dayjs/plugin/timezone');
var calendar = require('dayjs/plugin/calendar');
var updateLocale = require('dayjs/plugin/updateLocale')

dayjs.extend(utc);
dayjs.extend(calendar);
dayjs.extend(timezone);
dayjs.extend(updateLocale);

dayjs.updateLocale('en', {
  calendar: {
    sameDay: '[Today]',
    nextDay: '[Tomorrow]', 
    nextWeek: 'dddd', 
    lastDay: '[Yesterday]', 
    lastWeek: 'dddd',
    sameElse: 'dddd'
  }
})

export default {
  name:"PostRow",

  components: {
      PagePhoto,
      BadgeStatus,
      TrashIcon,
      DropDown,
      MediaDisplay
  },
  props: {
    item: {
      item: Object,
      required: true
    },
    postId: {
      item: Number,
      required: true
    },
  },

  methods: {
    isGroupCover(page) {
      let metadata = JSON.parse(page.metadata);

      if(page.type === 'group') {
        if(metadata['cover'] && metadata['cover']['source']) {
          return true;
        } 

        return false;
      }

      return false;
    },

    confirmDelete(item) {
      this.$emit('confirmDelete',item)
    },
    getAccountImageUrl(page){
      if(page.type === 'group') {
        let metadata = JSON.parse(page.metadata);
        if(metadata['cover'] && metadata['cover']['source']) {
          return metadata['cover']['source'];
        } 

        return metadata['icon'];
      }

      return JSON.parse(page.metadata)['picture']['data']['url'];
    },
  },

  computed: {
    postDateMonthTime: function() {
      var clientTimezoneOffset = -(new Date().getTimezoneOffset()/60);
      return this.item.post_date ? dayjs(this.item.post_date).add(clientTimezoneOffset, 'hour').format('MMM D @ h:mma') : 'No date yet';
    },
    postDateDay: function() {
      var clientTimezoneOffset = -(new Date().getTimezoneOffset()/60);
      return this.item.post_date ? dayjs(this.item.post_date).add(clientTimezoneOffset, 'hour').calendar(dayjs()) : '';
    },
  }
}
</script>